import { render } from "./store-form.vue?vue&type=template&id=af943e8a&scoped=true&ts=true"
import script from "./store-form.vue?vue&type=script&lang=ts"
export * from "./store-form.vue?vue&type=script&lang=ts"

import "./store-form.vue?vue&type=style&index=0&id=af943e8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af943e8a"]])

export default __exports__